var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsSection',{attrs:{"tabs":_vm.tabs,"articles":_vm.articles}})
}
var staticRenderFns = []

export { render, staticRenderFns }